// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  padding: 0.5rem;
  width: 117px;
  /* background: linear-gradient(to bottom, #595959 0%, #595959 80%, #DA7027 100%); */
  /* border-right: 2px solid #2C3948; */
  background: #484848;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  z-index: 1000;
  color: #fffdfc;
}

.sidebar .first-section {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  height: 100vh;
  justify-content: center;
  width: 100%;
}

.sidebar.collapsed {
  width: 80px;
}

.collapse-btn {
  width: 33px;
  height: 33px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: fixed;
  left: 17.8rem;
  top: 50vh;
}

.titre-espace,
.sidebar .name {
  font-weight: 700;
}

.collapse-btn.collapsed {
  left: 6.7rem;
}

.collapse-arrow {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.collapse-arrow.collapsed {
  transform: rotate(180deg);
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.logo-section {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.logo-section svg {
  height: 60px;
  width: 180px;
}

.logo-collapsed {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.logo-collapsed::before {
  content: "";
  position: absolute;
  width: 48px;
  height: 48px;
  background-color: #d7d9d9;
  border-radius: 50%;
  z-index: 0;
}

.logo-collapsed svg {
  position: relative;
  z-index: 1;
}

.sidebar-header .user-info {
  font-weight: bold;
}

.sidebar .user-info .org {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.sidebar-menu {
  list-style: none;
  margin: 1rem 0;
  /* height: 60%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.sidebar-link {
  /* display: flex; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: 400;
  color: #fffdfc;
  padding: 1rem 0.5rem;
  border-radius: 8px;
  gap: 0.5rem;
  width: 100%;
}

.sidebar-link:hover,
.sidebar-link.active {
  background: rgba(255, 128, 0, 0.5);
  color: #fffdfc !important;
  cursor: pointer;
}

.sidebar-link.active {
  font-weight: 900;
}

.sidebar-link span {
  margin: auto;
}

.icon,
.icon-white {
  width: 28px;
  height: 28px;
  /* fill: white; */
  /* margin: auto; */
}

/* .icon path {
  fill: #2C3948;
} */

.sidebar .badge {
  background: #e2411d;
  color: #fffdfc;
  border-radius: 9999px; /* rend la forme pill */
  padding: 0 0.5em; /* horizontal padding adaptable */
  height: 22px;
  font-size: 1.2rem;
  line-height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.5em;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 22px; /* pour garder une taille minimum */
}

.sidebar .badge {
  position: absolute;
  right: 13px;
  top: 0;
}

.sidebar li {
  position: relative;
}

.sidebar.collapsed .badge {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 10px;
  top: 92px;
  padding: 0;
  font-size: 1.2rem;
}

.logout-btn {
  border: none;
  background-color: transparent;
  width: 100%;
}

.logout-btn span {
  font-weight: 400;
}

/* Augmente la taille des icônes quand la sidebar est repliée */
.sidebar.collapsed .icon,
.sidebar.collapsed .icon-white {
  width: 35px;
  height: 35px;
}

/* Place la notification (badge) à côté de l'icône quand la sidebar est repliée */
.sidebar.collapsed .badge {
  display: inline-flex;
  vertical-align: middle;
  margin-left: 6px;
  width: 18px;
  height: 18px;
  font-size: 1.1rem;
  line-height: 18px;
  padding: 0;
  top: 0;
  right: 7px;
}

.sidebar-link.disabled {
  color: #999; /* gris */
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5; /* grise le texte et l'icône */
}

.sidebar-link.disabled .icon {
  fill: #aaa; /* si tes icônes sont des SVG, ça change la couleur */
}

/* FRONT-10: Badge d'avertissement profil incomplet */
.sidebar .badge-warning {
  background: #e2411d;
  color: #fffdfc;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 5px;
}

.sidebar.collapsed .badge-warning {
  width: 16px;
  height: 16px;
  font-size: 0.9rem;
  right: 7px;
  top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,mFAAmF;EACnF,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,mDAAmD;EACnD,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB,EAAE,uBAAuB;EAC9C,gBAAgB,EAAE,iCAAiC;EACnD,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iDAAiD;EACjD,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,iFAAiF;AACjF;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,WAAW,EAAE,SAAS;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY,EAAE,8BAA8B;AAC9C;;AAEA;EACE,UAAU,EAAE,qDAAqD;AACnE;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,QAAQ;AACV","sourcesContent":[".sidebar {\r\n  padding: 0.5rem;\r\n  width: 117px;\r\n  /* background: linear-gradient(to bottom, #595959 0%, #595959 80%, #DA7027 100%); */\r\n  /* border-right: 2px solid #2C3948; */\r\n  background: #484848;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  overflow-y: auto;\r\n  z-index: 1000;\r\n  color: #fffdfc;\r\n}\r\n\r\n.sidebar .first-section {\r\n  display: flex;\r\n  align-content: space-between;\r\n  flex-wrap: wrap;\r\n  height: 100vh;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 80px;\r\n}\r\n\r\n.collapse-btn {\r\n  width: 33px;\r\n  height: 33px;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: fixed;\r\n  left: 17.8rem;\r\n  top: 50vh;\r\n}\r\n\r\n.titre-espace,\r\n.sidebar .name {\r\n  font-weight: 700;\r\n}\r\n\r\n.collapse-btn.collapsed {\r\n  left: 6.7rem;\r\n}\r\n\r\n.collapse-arrow {\r\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.collapse-arrow.collapsed {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.sidebar-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.logo-section {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.logo-section {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n}\r\n\r\n.logo-section svg {\r\n  height: 60px;\r\n  width: 180px;\r\n}\r\n\r\n.logo-collapsed {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.logo-collapsed::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 48px;\r\n  height: 48px;\r\n  background-color: #d7d9d9;\r\n  border-radius: 50%;\r\n  z-index: 0;\r\n}\r\n\r\n.logo-collapsed svg {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.sidebar-header .user-info {\r\n  font-weight: bold;\r\n}\r\n\r\n.sidebar .user-info .org {\r\n  font-size: 1.8rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.sidebar-menu {\r\n  list-style: none;\r\n  margin: 1rem 0;\r\n  /* height: 60%; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.sidebar-link {\r\n  /* display: flex; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  font-weight: 400;\r\n  color: #fffdfc;\r\n  padding: 1rem 0.5rem;\r\n  border-radius: 8px;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n}\r\n\r\n.sidebar-link:hover,\r\n.sidebar-link.active {\r\n  background: rgba(255, 128, 0, 0.5);\r\n  color: #fffdfc !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-link.active {\r\n  font-weight: 900;\r\n}\r\n\r\n.sidebar-link span {\r\n  margin: auto;\r\n}\r\n\r\n.icon,\r\n.icon-white {\r\n  width: 28px;\r\n  height: 28px;\r\n  /* fill: white; */\r\n  /* margin: auto; */\r\n}\r\n\r\n/* .icon path {\r\n  fill: #2C3948;\r\n} */\r\n\r\n.sidebar .badge {\r\n  background: #e2411d;\r\n  color: #fffdfc;\r\n  border-radius: 9999px; /* rend la forme pill */\r\n  padding: 0 0.5em; /* horizontal padding adaptable */\r\n  height: 22px;\r\n  font-size: 1.2rem;\r\n  line-height: 22px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: 0.5em;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  min-width: 22px; /* pour garder une taille minimum */\r\n}\r\n\r\n.sidebar .badge {\r\n  position: absolute;\r\n  right: 13px;\r\n  top: 0;\r\n}\r\n\r\n.sidebar li {\r\n  position: relative;\r\n}\r\n\r\n.sidebar.collapsed .badge {\r\n  width: 15px;\r\n  height: 15px;\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 92px;\r\n  padding: 0;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.logout-btn {\r\n  border: none;\r\n  background-color: transparent;\r\n  width: 100%;\r\n}\r\n\r\n.logout-btn span {\r\n  font-weight: 400;\r\n}\r\n\r\n/* Augmente la taille des icônes quand la sidebar est repliée */\r\n.sidebar.collapsed .icon,\r\n.sidebar.collapsed .icon-white {\r\n  width: 35px;\r\n  height: 35px;\r\n}\r\n\r\n/* Place la notification (badge) à côté de l'icône quand la sidebar est repliée */\r\n.sidebar.collapsed .badge {\r\n  display: inline-flex;\r\n  vertical-align: middle;\r\n  margin-left: 6px;\r\n  width: 18px;\r\n  height: 18px;\r\n  font-size: 1.1rem;\r\n  line-height: 18px;\r\n  padding: 0;\r\n  top: 0;\r\n  right: 7px;\r\n}\r\n\r\n.sidebar-link.disabled {\r\n  color: #999; /* gris */\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n  opacity: 0.5; /* grise le texte et l'icône */\r\n}\r\n\r\n.sidebar-link.disabled .icon {\r\n  fill: #aaa; /* si tes icônes sont des SVG, ça change la couleur */\r\n}\r\n\r\n/* FRONT-10: Badge d'avertissement profil incomplet */\r\n.sidebar .badge-warning {\r\n  background: #e2411d;\r\n  color: #fffdfc;\r\n  border-radius: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  font-size: 1rem;\r\n  font-weight: bold;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 5px;\r\n}\r\n\r\n.sidebar.collapsed .badge-warning {\r\n  width: 16px;\r\n  height: 16px;\r\n  font-size: 0.9rem;\r\n  right: 7px;\r\n  top: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
